<div class="mt-3 p-1 animated fadeIn">

  <div class="form-group d-flex flex-row filter-group">
    <!-- Publication Search Input -->
    <div class="col-md-4">
      <input type="text" class="form-control" placeholder="Publication Search" autocomplete="false"
        [(ngModel)]="searchField" autocomplete="off" aria="combobox" (input)="onSearchChange($event.target.value)">
    </div>

    <!-- Year Sorting -->
    <select class="form-control" [(ngModel)]="yearOrder" aria-label="Sort by year">
      <ng-container>
        <option class="truncate-label" value="1">Year Ascending</option>
        <option class="truncate-label" value="2">Year Descending</option>
      </ng-container>
    </select>
  </div>

  <h4>Publications</h4>

  <!-- Ascending -->
  <div *ngIf="yearOrder == 1">
    <ng-container *ngIf="journalsView | async | sortBy: 'asc':'year' as items; else loading">
      <ng-container *ngFor="let item of items | slice: (page-1) * pageSize : (page-1) * pageSize + pageSize;">
        <div class="mb-2" *ngIf="item?.title && item?.journalTitle">
          <h6>{{ item.title | plainText }}</h6>
          <div class="col d-flex flex-column">
            <span role="contentinfo">Journal: {{ item.journalTitle | plainText }} </span>
            <span role="contentinfo">Volume: {{ item.volume }}</span>
            <span role="contentinfo">Year Published: {{ item.year }}</span>
            <div class="d-flex flex-row flex-wrap">Authors:
              <ng-container *ngFor="let author of item.authors; let last = last">
                <span role="contentinfo">&nbsp;{{ formatAuthorName(author) | plainText }}</span>
                <span *ngIf="!last" role="contentinfo">,</span>
              </ng-container>
            </div>
          </div>
        </div>
      </ng-container>
    </ng-container>
  </div>

  <!-- Descending -->
  <div *ngIf="yearOrder == 2">
    <ng-container *ngIf="journalsView | async | sortBy: 'desc':'year' as items; else loading">
      <ng-container *ngFor="let item of items | slice: (page-1) * pageSize : (page-1) * pageSize + pageSize;">
        <div class="mb-2" *ngIf="item?.title && item?.journalTitle">
          <h6>{{ item.title | plainText }}</h6>
          <div class="col d-flex flex-column">
            <span role="contentinfo">Journal: {{ item.journalTitle | plainText }} </span>
            <span role="contentinfo">Volume: {{ item.volume }}</span>
            <span role="contentinfo">Year Published: {{ item.year }}</span>
            <div class="d-flex flex-row flex-wrap">Authors:
              <ng-container *ngFor="let author of item.authors; let last = last">
                <span role="contentinfo">&nbsp;{{ formatAuthorName(author) | plainText }}</span>
                <span *ngIf="!last" role="contentinfo">,</span>
              </ng-container>
            </div>
          </div>
        </div>
      </ng-container>
    </ng-container>
  </div>
</div>

<!-- Pagination -->
<div class="row mt-3">
  <div class="col-md-12 d-flex justify-content-end">
    <ngb-pagination [(page)]="page" [pageSize]="pageSize" [collectionSize]="(journalsView | async)?.length || 0"
      [directionLinks]="false" [boundaryLinks]="true" [maxSize]="5" [rotate]="true" [ellipses]="false">
    </ngb-pagination>
  </div>
</div>
<!-- Pagination -->

<ng-template #loading>
  <ngx-skeleton-loader count="10"></ngx-skeleton-loader>
</ng-template>